module.exports = __webpack_public_path__ + "static/media/cargozilla.e7fc5bf4.svg";